import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MagnifyImage } from "../../../CommonComponents/MagnifyImage";
import { RxCross1 } from "react-icons/rx";

function CartDetail() {

  const id = useLocation();
  const objectId = id && id.state;

  const BASE_URL = process.env.REACT_APP_PP_URL;
  const token = sessionStorage.getItem('tokenKey');

  const [info, setInfo] = useState();
  const detail = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/v1/order/getCartDetail/${objectId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        setInfo(getRes.responsePacket)
      }
    } catch (e) {
      console.log(e, 'error in detail api of cart')
    }
  };

  useEffect(() => {
    detail();
  }, []);

  // Image Magifinify
  const [imgUrl, setImgUrl] = useState();
  const [showImg, setShowImg] = useState(false);
  const maginifyImage = (e) => {
    setShowImg(true);
    setImgUrl(e);
  };
  let navigate = useNavigate();

  return (
    <>
      <div className="order-detail">
        <div className="orderr">
          <div className="card-order">
            <span style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #ddd", cursor: "pointer" }}>
              <h3 className="card-title" style={{ borderBottom: "1px white solid" }}>Customer Detail</h3>
              <span onClick={() => navigate(-1)}><RxCross1 /></span></span>

            <div className="row">
              <span className="label">Full Name</span>
              <span className="value">{info?.customerDetail?.userCustomerFirstName}</span>
            </div>
            <div className="row">
              <span className="label">Mobile Number</span>
              <span className="value">{info?.customerDetail?.userCustomerMobile}</span>
            </div>
            <div className="row">
              <span className="label">Email</span>
              <span className="value"> {info?.customerDetail?.userCustomerEmail}</span>
            </div>
          </div>
        </div>

        <div className="ordered-item-container">
          <div className="card-b">
            <h3 className="card-title">Ordered Item Details</h3>
            <table className="item-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>MRP</th>
                  <th>Selling Price</th>
                  <th>Qty.</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>

                {info?.itemDetailList?.map((item, index) => (
                  <tr key={item.id}>

                    <td style={{ width: "20%" }}>
                      <div className="img" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={item?.itemImageUrls?.[0]} alt="img" width={50} style={{ width: "40%", height: "100px", }} onClick={() => maginifyImage(item?.itemImageUrls?.[0])} loading="lazy" />
                      </div>
                    </td>
                    <td >
                      {item.title} <span className="info-icon"></span>
                    </td>
                    <td>{item.mrp}</td>
                    <td>{item.sellingPrice}</td>
                    <td>{item.quantity}</td>
                    <td>{item.sellingPrice * item.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Order Summary */}
            <div className="summary">
              <div className="summary-row">
                <span>Item Total</span>
                <span>{info?.subTotal}</span>
              </div>
              <div className="summary-row">
                <span>Coupon Discount</span>
                <span className="negative">{info?.couponDiscountAmount}</span>
              </div>
              <div className="summary-row">
                <span>Delivery Charges</span>
                <div>
                  <div>{info?.deliveryCharges}</div>
                </div>
              </div>
              <div className="summary-row">
                <span>Packing Charges</span>
                <div>
                  <div>{info?.packingCharges}</div>
                </div>
              </div>
              <div className="summary-row total">
                <span>Order Total</span>
                <span>{info?.orderTotal}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MagnifyImage isOpen={showImg} imgSrc={imgUrl} onClose={() => setShowImg(false)} />

    </>
  );
}

export default CartDetail;

